import { BackendInstances, FirebaseInstances } from '../interfaces';

export function getBackEndInstance(): string {
  let backendInstance = '';
  const origin = window.location.origin;
  const regex = new RegExp('-pr-[0-9]+');
  const firebaseToBackEndInstances = {
    [FirebaseInstances.STAGING]: BackendInstances.STAGING,
    [FirebaseInstances.STAGING_TABLESREADY]: BackendInstances.STAGING,
    [FirebaseInstances.DOCKMAGIC_PROD]: BackendInstances.DOCKMAGIC_PROD,
    [FirebaseInstances.APP_DOCKMAGIC]: BackendInstances.DOCKMAGIC_PROD,
    [FirebaseInstances.TABLESREADY_PROD]: BackendInstances.TABLESREADY_PROD,
    [FirebaseInstances.HOST_TABLESREADY]: BackendInstances.TABLESREADY_PROD,
    [FirebaseInstances.APP_TABLESREADY]: BackendInstances.TABLESREADY_PROD,
  };

  for (let [key, value] of Object.entries(firebaseToBackEndInstances)) {
    if (origin.includes(key) && regex.test(origin)) {
      const matchedValue = origin.match(regex)[0];
      backendInstance = BackendInstances.TEST_STAGING + matchedValue + '.herokuapp.com';
      break;
    }

    if (origin.includes(key)) {
      backendInstance = value;
      break;
    }
  }

  return backendInstance;
}
